export const WNTR_EDITION = ['winter', 'ice_breaker'];
const STELLAR_EDITION = ['stellar'];

export const SET_EDITION = [WNTR_EDITION, STELLAR_EDITION].flat();

export const SUPPORTED_CARD_SETS = [
  'winter' as const,
  'common-base-set' as const,
];
export type SupportedCardSet = (typeof SUPPORTED_CARD_SETS)[number];

export const isSupportedCardSet = (
  setSlug: Nullable<string>
): setSlug is SupportedCardSet => {
  if (!setSlug) {
    return false;
  }
  return SUPPORTED_CARD_SETS.some(supportedSet => supportedSet === setSlug);
};

export const isSpecialCardSet = (setSlug: Nullable<string>) => {
  return !!setSlug && setSlug !== 'common-base-set';
};

export const getDisplayCardSetName = (setSlug: Nullable<string>) => {
  if (setSlug === 'winter') {
    return 'WNTR';
  }
  return setSlug;
};
